import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #000; /* Black background for the navbar */
  border-bottom: 1px solid #333; /* Optional: subtle border for separation */
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

export const NavLink = styled(Link)`
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #000; /* Black text color */
  font-weight: bold;
  border-radius: 20px;
  background-color: #fff; /* White background for buttons */
  transition: background-color 0.3s, transform 0.3s;
  font-size: 1rem;

  &:hover {
    background-color: #ddd; /* Slightly darker on hover */
    transform: scale(1.05);
  }

  &:active {
    background-color: #ccc; /* Even darker on click */
  }
`;

export const LoginButton = styled(Link)`
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #000; /* Black text color */
  background-color: #fff; /* White background for the login button */
  border-radius: 20px;
  font-weight: bold;
  transition: background-color 0.3s, transform 0.3s;
  font-size: 1rem;

  &:hover {
    background-color: #ddd; /* Slightly darker on hover */
    transform: scale(1.05);
  }

  &:active {
    background-color: #ccc; /* Even darker on click */
  }
`;
